/**
 * Friendly empty state for pages a user doesn't have permission to see, or
 * routes that don't resolve. The copy is deliberately bland — we don't tell
 * the visitor what they're missing or how to get it. They take it up with
 * their senior.
 */
export function NothingToSeeHere({ subtitle }: { subtitle?: string }) {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "80px 24px",
        color: "var(--muted)",
      }}
    >
      <div style={{ fontSize: 36, opacity: 0.5, marginBottom: 12 }}>·</div>
      <div style={{ fontSize: 18, fontWeight: 500, color: "var(--text)" }}>
        Nothing to see here
      </div>
      {subtitle && (
        <div style={{ fontSize: 13, marginTop: 8, maxWidth: 360, marginInline: "auto" }}>
          {subtitle}
        </div>
      )}
    </div>
  );
}
